import React, { useEffect, useRef, useState } from "react";

const MobileMainDesc = () => {
  const imgRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.6 } // shows overlay when 60% of image is visible
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) observer.unobserve(imgRef.current);
    };
  }, []);

  return (
    <div className="flex flex-col items-center">
      {/* Cartier image section */}
      <div className="pt-6 px-4 w-full flex justify-center relative">
        <a
          href="cartier-@-miami-design-district"
          className="relative max-w-md w-full mx-auto"
        >
          {/* Image */}
          <img
            ref={imgRef}
            src={"prjimg/Cartier/Cartier3.webp"}
            className="w-full rounded-md"
          />

          {/* Overlay text when in view */}
          <div
            className={`
              absolute inset-0 flex items-center justify-center
              bg-black/40 text-white text-lg font-bold rounded-md 
              transition-opacity duration-300
              ${inView ? "opacity-100" : "opacity-0"}
            `}
          >
            Learn about our Cartier installation here!
          </div>
        </a>
      </div>
      <div className="flex p-0">
        <div className="flex p-6 items-center font-display font-bold text-navy pb-2 pt-0">
        <div className="flex items-center p-4 w-full justify-around">
            <div className="flex w-1/2 text-7xl justify-center items-center whitespace-nowrap pr-8 text-center">
              #7
            </div>
            <div className="flex flex-col w-1/2 items-center justify-center">
              <div className="text-3xl text-center mt-5">
              Ranked Glazier in the <br />
              Nation by{" "}
            
          </div>
              <img className="flex w-1/2 p-2"src="various/enrlogo.webp" alt="" />
            </div>
            
        </div>
      </div>

      </div>
      {/* 50 years logo */}

      <div>
        <img className="flex object-contain p-8 pt-2" src={"/various/splitscreen.webp"} />
      </div>

      {/* Main text */}
      <h1 className="font-display text-center text-xl p-6 pt-0 text-navy">
        Visionaries since 1973. At Massey's, our legacy speaks for itself. We've
        been the cornerstone of architectural innovation for over five decades.
        <br />
        <br />
        We're not just industry leaders; we're pioneers, collaborating with the
        foremost manufacturers in glazing materials and cutting-edge
        installation techniques. Our dedication to excellence transcends
        craftsmanship; it's a commitment to shaping the future of architectural
        possibilities.
        <br />
        <br />
        We foster an inclusive environment, championing equal opportunities for
        all, irrespective of race, gender, or ability. At Massey's, diversity
        fuels our success.
        <br />
        <br />
        Rooted in a proud heritage and propelled by unwavering confidence,
        Massey's invites you to build with confidence.
      </h1>

      <div className="w-1/3 p-6 flex justify-center">
        <img src={"/various/50yrs.webp"} />
      </div>
    </div>
  );
};

export default MobileMainDesc;
